import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { clear as _clear, drawConnectLine as _drawConnectLine, drawGrabLine as _drawGrabLine, drawParticle as _drawParticle, drawParticlePlugin as _drawParticlePlugin, drawPlugin as _drawPlugin, gradient, paintBase as _paintBase } from "../Utils/CanvasUtils";
import { colorToHsl, colorToRgb, getStyleFromHsl, getStyleFromRgb } from "../Utils/ColorUtils";
import { Constants } from "./Utils/Constants";
import { deepExtend } from "../Utils/Utils";
export var Canvas = /*#__PURE__*/function () {
  function Canvas(container) {
    _classCallCheck(this, Canvas);
    this.container = container;
    this.size = {
      height: 0,
      width: 0
    };
    this.context = null;
    this.generatedCanvas = false;
  }
  _createClass(Canvas, [{
    key: "init",
    value: function init() {
      this.resize();
      this.initStyle();
      this.initCover();
      this.initTrail();
      this.initBackground();
      this.paint();
    }
  }, {
    key: "loadCanvas",
    value: function loadCanvas(canvas) {
      var _a;
      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }
      this.generatedCanvas = canvas.dataset && Constants.generatedAttribute in canvas.dataset ? canvas.dataset[Constants.generatedAttribute] === "true" : this.generatedCanvas;
      this.element = canvas;
      this.originalStyle = deepExtend({}, this.element.style);
      this.size.height = canvas.offsetHeight;
      this.size.width = canvas.offsetWidth;
      this.context = this.element.getContext("2d");
      this.container.retina.init();
      this.initBackground();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this = this;
      var _a;
      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }
      this.draw(function (ctx) {
        _clear(ctx, _this.size);
      });
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this2 = this;
      var options = this.container.actualOptions;
      this.draw(function (ctx) {
        if (options.backgroundMask.enable && options.backgroundMask.cover) {
          _clear(ctx, _this2.size);
          _this2.paintBase(_this2.coverColorStyle);
        } else {
          _this2.paintBase();
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;
      var options = this.container.actualOptions,
        trail = options.particles.move.trail;
      if (options.backgroundMask.enable) {
        this.paint();
      } else if (trail.enable && trail.length > 0 && this.trailFillColor) {
        this.paintBase(getStyleFromRgb(this.trailFillColor, 1 / trail.length));
      } else {
        this.draw(function (ctx) {
          _clear(ctx, _this3.size);
        });
      }
    }
  }, {
    key: "windowResize",
    value: function () {
      var _windowResize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var container, needsRefresh, _iterator, _step, _step$value, plugin;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.element) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              this.resize();
              container = this.container, needsRefresh = container.updateActualOptions();
              container.particles.setDensity();
              _iterator = _createForOfIteratorHelper(container.plugins);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _slicedToArray(_step.value, 2), plugin = _step$value[1];
                  if (plugin.resize !== undefined) {
                    plugin.resize();
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              if (!needsRefresh) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return container.refresh();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function windowResize() {
        return _windowResize.apply(this, arguments);
      }
      return windowResize;
    }()
  }, {
    key: "resize",
    value: function resize() {
      if (!this.element) {
        return;
      }
      var container = this.container,
        pxRatio = container.retina.pixelRatio,
        size = container.canvas.size,
        newSize = {
          width: this.element.offsetWidth * pxRatio,
          height: this.element.offsetHeight * pxRatio
        };
      if (newSize.height === size.height && newSize.width === size.width && newSize.height === this.element.height && newSize.width === this.element.width) {
        return;
      }
      var oldSize = Object.assign({}, size);
      this.element.width = size.width = this.element.offsetWidth * pxRatio;
      this.element.height = size.height = this.element.offsetHeight * pxRatio;
      if (this.container.started) {
        this.resizeFactor = {
          width: size.width / oldSize.width,
          height: size.height / oldSize.height
        };
      }
    }
  }, {
    key: "drawConnectLine",
    value: function drawConnectLine(p1, p2) {
      var _this4 = this;
      this.draw(function (ctx) {
        var _a;
        var lineStyle = _this4.lineStyle(p1, p2);
        if (!lineStyle) {
          return;
        }
        var pos1 = p1.getPosition(),
          pos2 = p2.getPosition();
        _drawConnectLine(ctx, (_a = p1.retina.linksWidth) !== null && _a !== void 0 ? _a : _this4.container.retina.linksWidth, lineStyle, pos1, pos2);
      });
    }
  }, {
    key: "drawGrabLine",
    value: function drawGrabLine(particle, lineColor, opacity, mousePos) {
      var container = this.container;
      this.draw(function (ctx) {
        var _a;
        var beginPos = particle.getPosition();
        _drawGrabLine(ctx, (_a = particle.retina.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth, beginPos, mousePos, lineColor, opacity);
      });
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(particle, delta) {
      var _this5 = this;
      var _a, _b, _c, _d, _e, _f;
      if (particle.spawning || particle.destroyed) {
        return;
      }
      var radius = particle.getRadius();
      if (radius <= 0) {
        return;
      }
      var pfColor = particle.getFillColor(),
        psColor = (_a = particle.getStrokeColor()) !== null && _a !== void 0 ? _a : pfColor;
      if (!pfColor && !psColor) {
        return;
      }
      var _this$getPluginPartic = this.getPluginParticleColors(particle),
        _this$getPluginPartic2 = _slicedToArray(_this$getPluginPartic, 2),
        fColor = _this$getPluginPartic2[0],
        sColor = _this$getPluginPartic2[1];
      if (!fColor || !sColor) {
        if (!fColor) {
          fColor = pfColor ? pfColor : undefined;
        }
        if (!sColor) {
          sColor = psColor ? psColor : undefined;
        }
      }
      var options = this.container.actualOptions,
        zIndexOptions = particle.options.zIndex,
        zOpacityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.opacityRate),
        opacity = (_d = (_b = particle.bubble.opacity) !== null && _b !== void 0 ? _b : (_c = particle.opacity) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 1,
        strokeOpacity = (_f = (_e = particle.stroke) === null || _e === void 0 ? void 0 : _e.opacity) !== null && _f !== void 0 ? _f : opacity,
        zOpacity = opacity * zOpacityFactor,
        zStrokeOpacity = strokeOpacity * zOpacityFactor;
      var colorStyles = {
        fill: fColor ? getStyleFromHsl(fColor, zOpacity) : undefined
      };
      colorStyles.stroke = sColor ? getStyleFromHsl(sColor, zStrokeOpacity) : colorStyles.fill;
      this.draw(function (ctx) {
        var zSizeFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.sizeRate),
          container = _this5.container;
        var _iterator2 = _createForOfIteratorHelper(container.particles.updaters),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var updater = _step2.value;
            if (updater.beforeDraw) {
              updater.beforeDraw(particle);
            }
            if (updater.getColorStyles) {
              var _updater$getColorStyl = updater.getColorStyles(particle, ctx, radius, zOpacity),
                fill = _updater$getColorStyl.fill,
                stroke = _updater$getColorStyl.stroke;
              if (fill) {
                colorStyles.fill = fill;
              }
              if (stroke) {
                colorStyles.stroke = stroke;
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        _drawParticle(container, ctx, particle, delta, colorStyles, options.backgroundMask.enable, options.backgroundMask.composite, radius * zSizeFactor, zOpacity, particle.options.shadow);
        var _iterator3 = _createForOfIteratorHelper(container.particles.updaters),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _updater = _step3.value;
            if (_updater.afterDraw) {
              _updater.afterDraw(particle);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
    }
  }, {
    key: "drawPlugin",
    value: function drawPlugin(plugin, delta) {
      this.draw(function (ctx) {
        _drawPlugin(ctx, plugin, delta);
      });
    }
  }, {
    key: "drawParticlePlugin",
    value: function drawParticlePlugin(plugin, particle, delta) {
      this.draw(function (ctx) {
        _drawParticlePlugin(ctx, plugin, particle, delta);
      });
    }
  }, {
    key: "initBackground",
    value: function initBackground() {
      var options = this.container.actualOptions,
        background = options.background,
        element = this.element,
        elementStyle = element === null || element === void 0 ? void 0 : element.style;
      if (!elementStyle) {
        return;
      }
      if (background.color) {
        var color = colorToRgb(background.color);
        elementStyle.backgroundColor = color ? getStyleFromRgb(color, background.opacity) : "";
      } else {
        elementStyle.backgroundColor = "";
      }
      elementStyle.backgroundImage = background.image || "";
      elementStyle.backgroundPosition = background.position || "";
      elementStyle.backgroundRepeat = background.repeat || "";
      elementStyle.backgroundSize = background.size || "";
    }
  }, {
    key: "draw",
    value: function draw(cb) {
      if (!this.context) {
        return;
      }
      return cb(this.context);
    }
  }, {
    key: "initCover",
    value: function initCover() {
      var options = this.container.actualOptions,
        cover = options.backgroundMask.cover,
        color = cover.color,
        coverRgb = colorToRgb(color);
      if (coverRgb) {
        var coverColor = {
          r: coverRgb.r,
          g: coverRgb.g,
          b: coverRgb.b,
          a: cover.opacity
        };
        this.coverColorStyle = getStyleFromRgb(coverColor, coverColor.a);
      }
    }
  }, {
    key: "initTrail",
    value: function initTrail() {
      var options = this.container.actualOptions,
        trail = options.particles.move.trail,
        fillColor = colorToRgb(trail.fillColor);
      if (fillColor) {
        var _trail = options.particles.move.trail;
        this.trailFillColor = {
          r: fillColor.r,
          g: fillColor.g,
          b: fillColor.b,
          a: 1 / _trail.length
        };
      }
    }
  }, {
    key: "getPluginParticleColors",
    value: function getPluginParticleColors(particle) {
      var fColor, sColor;
      var _iterator4 = _createForOfIteratorHelper(this.container.plugins),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
            plugin = _step4$value[1];
          if (!fColor && plugin.particleFillColor) {
            fColor = colorToHsl(plugin.particleFillColor(particle));
          }
          if (!sColor && plugin.particleStrokeColor) {
            sColor = colorToHsl(plugin.particleStrokeColor(particle));
          }
          if (fColor && sColor) {
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return [fColor, sColor];
    }
  }, {
    key: "initStyle",
    value: function initStyle() {
      var element = this.element,
        options = this.container.actualOptions;
      if (!element) {
        return;
      }
      var originalStyle = this.originalStyle;
      if (options.fullScreen.enable) {
        this.originalStyle = deepExtend({}, element.style);
        element.style.setProperty("position", "fixed", "important");
        element.style.setProperty("z-index", options.fullScreen.zIndex.toString(10), "important");
        element.style.setProperty("top", "0", "important");
        element.style.setProperty("left", "0", "important");
        element.style.setProperty("width", "100%", "important");
        element.style.setProperty("height", "100%", "important");
      } else if (originalStyle) {
        element.style.position = originalStyle.position;
        element.style.zIndex = originalStyle.zIndex;
        element.style.top = originalStyle.top;
        element.style.left = originalStyle.left;
        element.style.width = originalStyle.width;
        element.style.height = originalStyle.height;
      }
      for (var key in options.style) {
        if (!key || !options.style) {
          continue;
        }
        var value = options.style[key];
        if (!value) {
          continue;
        }
        element.style.setProperty(key, value, "important");
      }
    }
  }, {
    key: "paintBase",
    value: function paintBase(baseColor) {
      var _this6 = this;
      this.draw(function (ctx) {
        _paintBase(ctx, _this6.size, baseColor);
      });
    }
  }, {
    key: "lineStyle",
    value: function lineStyle(p1, p2) {
      var _this7 = this;
      return this.draw(function (ctx) {
        var options = _this7.container.actualOptions,
          connectOptions = options.interactivity.modes.connect;
        return gradient(ctx, p1, p2, connectOptions.links.opacity);
      });
    }
  }]);
  return Canvas;
}();